import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideQuillConfig } from 'ngx-quill/config';
import { appTokenInterceptor } from './utils/app-token-interceptor';

import { routes } from './app.routes';
import { userTokenInterceptor } from './utils/user-token-interceptor';
import { LanguageService } from './services/language.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([appTokenInterceptor, userTokenInterceptor])),
    provideQuillConfig({
      modules: {
        syntax: false,
      },
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'fr-FR',
        loader: provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
      }),
    ),
    provideAppInitializer(() => inject(LanguageService).init()),
  ],
};
